// Auth utilities
//
// The JWT is stored exclusively in an httpOnly cookie set by the server.
// JavaScript cannot read it, eliminating the XSS token-theft vector.
// Session state is tracked via an in-memory flag that is populated by a
// server round-trip on startup and reset to false on logout.

let _sessionActive = false;

/** Mark the session as active (called after a successful login/register or
 *  after the startup /users/profile/me check confirms the cookie is valid). */
export const setSessionActive = (value: boolean): void => {
  _sessionActive = value;
};

/** Returns true if an active session has been confirmed this page load. */
export const isTokenValid = (): boolean => _sessionActive;

/** Kept for backward compatibility — always returns null since the token is
 *  httpOnly and inaccessible to JavaScript. */
export const getToken = (): string | null => null;

/** Clear the in-memory session flag and any non-sensitive user metadata that
 *  was stored in localStorage.  The actual cookie is cleared by calling
 *  POST /api/auth/logout on the backend. */
export const clearAuth = (): void => {
  _sessionActive = false;
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userName');
  localStorage.removeItem('userPicture');
};

/** @deprecated Token is now httpOnly — no longer needed. Kept as a no-op so
 *  call sites compile without changes while they are updated. */
export const saveToken = (_token: string, _expiresIn?: string): void => { /* no-op */ };

/** @deprecated See saveToken. */
export const saveTokenFromJwt = (_token: string): void => { /* no-op */ };

/** @deprecated See saveToken. */
export const decodeToken = (_token: string): null => null;
